import { render, staticRenderFns } from "./ComercialV2VisaoDetalhada.vue?vue&type=template&id=bba326a4&"
import script from "./ComercialV2VisaoDetalhada.vue?vue&type=script&lang=js&"
export * from "./ComercialV2VisaoDetalhada.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports